import React, { useState } from "react";
import {
  DeleteOutline as TrashIcon,
  DoneOutline as SendIcon,
} from "@material-ui/icons";
import { Modal } from "../../Modal";
import * as http from "modules/app/utils/http";
import { toast } from "react-toastify";
import * as _ from "lodash";
import * as S from "./styles";
import { useContactsState } from "modules/app/contexts";
import { useTranslation } from "react-i18next";
import { getBase64 } from "modules/app/utils";

function bytesToSize(bytes) {
  var sizes = ["Bytes", "KB", "MB", "GB", "TB"];
  if (bytes == 0) return "0 Byte";
  var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
  return Math.round(bytes / Math.pow(1024, i), 2) + " " + sizes[i];
}

export default function FileAttachment({
  replySources,
  answerMessage,
  setAnswerMessage,
}) {
  const { currentContact } = useContactsState();
  const [loading, setLoading] = useState(false);
  const [file, setFile] = useState();
  const [fileModal, setFileModal] = useState(false);

  const { t } = useTranslation();

  function handleClose() {
    setFileModal(false);
    setFile(null);
    setLoading(false);
  }

  function changeFileModal(e) {
    // byte => KB => MB => Máximo 80MB
    const maxSize = 1 * 1000 * 1000 * 80;
    const file = e.target.files[0];
    e.target.value = "";

    if (file && file.size <= maxSize) {
      setFile(file);
      setFileModal(true);
    } else if (file?.size > maxSize) {
      toast.warn(t("Chat:attachment.maxSize"));
    }
  }

  async function handleConfirm() {
    setLoading(true);

    const base64 = await getBase64(file);

    http
      .sendAttachment({
        customerId: currentContact.id,
        base64: base64,
        filename: file.name,
        replySources: replySources,
        answerMessage: answerMessage,
      })
      .then(() => toast.success(t("Chat:attachment.success")))
      .catch(() => toast.warn(t("Chat:attachment.error")))
      .finally(() => {
        setAnswerMessage(null);
        handleClose();
      });
  }

  return (
    <>
      {fileModal && (
        <Modal
          size="small"
          open={fileModal}
          onClose={handleClose}
          title={t("Chat:attachment.title")}
        >
          <S.Container>
            <S.Content>
              <S.FileName>{file.name}</S.FileName>
              <S.FileSize>{bytesToSize(file.size)}</S.FileSize>

              <S.Actions>
                <S.CancelAction>
                  <S.BorderedButton color="#ED5565" onClick={handleClose}>
                    <TrashIcon />
                  </S.BorderedButton>

                  <S.ActionTitle color="#ED5565">
                    {t("Chat:attachment.cancel")}
                  </S.ActionTitle>
                </S.CancelAction>

                <S.SendAction>
                  <S.BorderedButton
                    disabled={loading}
                    color="#63afef"
                    onClick={handleConfirm}
                  >
                    {loading ? <S.Loading /> : <SendIcon />}
                  </S.BorderedButton>

                  <S.ActionTitle color="#63afef">
                    {t("Chat:attachment.send")}
                  </S.ActionTitle>
                </S.SendAction>
              </S.Actions>
            </S.Content>
          </S.Container>
        </Modal>
      )}

      <S.FileButton variant="text" component="label">
        <S.PDFIcon />

        <input
          type="file"
          accept="application/pdf"
          hidden
          onChange={changeFileModal}
        />
      </S.FileButton>
    </>
  );
}
